import { render, staticRenderFns } from "./Passenger.vue?vue&type=template&id=31a88c97&scoped=true&"
import script from "./Passenger.vue?vue&type=script&lang=js&"
export * from "./Passenger.vue?vue&type=script&lang=js&"
import style0 from "./Passenger.vue?vue&type=style&index=0&id=31a88c97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a88c97",
  null
  
)

export default component.exports